import React, { ReactNode } from 'react';
import clsx from 'clsx';
import { useSelector } from 'react-redux';
import { InputAdornment, OutlinedInputProps } from '@mui/material';
import { RootState } from 'store';
import ColorPalette from 'utils/ColorPalette';
import { AppTheme } from 'models/@types';
import StylesCMPInput from './_styles';

export interface ICMPInputProps extends OutlinedInputProps {
  onChanged?: (val: string) => void;
  startIcon?: ReactNode;
  endIcon?: ReactNode;
  hasError?: boolean;
  filled?: boolean;
  defaultVariant?: boolean;
  prevent?: boolean;
}

const CMPInput: React.FunctionComponent<ICMPInputProps> = ({
  onChanged,
  startIcon,
  endIcon,
  hasError,
  filled,
  defaultVariant = true,
  prevent,
  ...props
}) => {
  const appTheme = useSelector<RootState, AppTheme>(state => state.App.appTheme);
  const changed = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    if (prevent) {
      event.preventDefault();
      event.stopPropagation();
    }
    const val = event.target.value;
    if (onChanged) {
      onChanged(val);
    }
  };

  return (
    <StylesCMPInput
      onChange={changed}
      onFocus={event => {
        if (prevent) {
          event.preventDefault();
          event.stopPropagation();
        }
      }}
      onClick={event => {
        if (prevent) {
          event.preventDefault();
          event.stopPropagation();
        }
      }}
      sx={{
        borderColor: hasError ? ColorPalette.error : 'transparent',
        backgroundColor: theme =>
          filled
            ? defaultVariant
              ? theme.palette.mode === 'dark'
                ? theme.palette.background.default
                : theme.palette.filterCard
              : theme.palette.inputBg
            : undefined,
      }}
      classes={{
        root: appTheme === 'DARK' ? 'input-dark' : 'input-light',
        notchedOutline: clsx({ 'border-0': filled }),
      }}
      endAdornment={startIcon && <InputAdornment position="start">{startIcon}</InputAdornment>}
      startAdornment={endIcon && <InputAdornment position="end">{endIcon}</InputAdornment>}
      {...props}
    />
  );
};
export default CMPInput;
